import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { Backdrop } from "@mui/material";

/**
 * Full-page blocking loader — the single replacement for the duplicate
 * Dashbboard/LoaderDialog and PatientCensus/LoaderDialog components.
 *
 * Accepts `open` or the legacy `loader` prop so existing call sites keep
 * working unchanged. Pass `label` to tell the user what is loading.
 */
export default function FullPageLoader({
  open,
  loader,
  label = "",
  zIndex = 1203,
}) {
  const isOpen = Boolean(open ?? loader);
  return (
    <Backdrop
      open={isOpen}
      style={{
        zIndex,
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 14,
      }}
    >
      <CircularProgress
        style={{ color: "#9b51e0" }}
        role="status"
        aria-label={label || "Loading"}
        id="loader"
      />
      {label ? (
        <Typography
          style={{
            color: "#ffffff",
            fontFamily: "PoppinsMedium, sans-serif",
            fontSize: 14,
            textAlign: "center",
            maxWidth: 320,
          }}
        >
          {label}
        </Typography>
      ) : null}
    </Backdrop>
  );
}
